var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"notFound"}},[(_vm.isAuthenticated)?_c('notify-not-found'):_c('no-auth-screen')],1)}
var staticRenderFns = []

export { render, staticRenderFns }